@if (service.isValidated()) {
    <portal-dashboard></portal-dashboard>
} @else {
    <router-outlet></router-outlet>
}
